import { module } from 'modujs';
import 'select2/dist/js/select2.min.js';
import 'select2/dist/css/select2.min.css';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          focusin: {
            input: 'active',
          },
          focusout: {
            input: 'desactive',
          },
        }
    }

    init() {
      let $this = this;
      let items = this.$('select2');
      let placeholder = 'Choisir';
      if(items) {
        items.forEach(element => { 
          if(element.getAttribute('data-placeholder')) {
            placeholder = element.getAttribute('data-placeholder');
          }
          $(element).select2({
            placeholder: placeholder,
            allowClear: true,
          });
          $('#'+element.getAttribute('id')).on('change.select2', function() {
            $this.call('refresh', false, 'Filtres');
          });
        });
      }
    }

    active(e) {
      const target = e.currentTarget;
      const item = this.parent('item', target);
      item.classList.add('is-active');
    }

    desactive(e) {
      const target = e.currentTarget;
      const item = this.parent('item', target);
      if(target.value == "") {
        item.classList.remove('is-active');
      }
    }

    toggleSelect(id) {
      $('#departement').val(id).trigger('change');
    }
}
